import React__default from 'react';

/**
 * Render the footer of the calendar.
 *
 * @group Components
 * @see https://daypicker.dev/guides/custom-components
 */
function Footer(props) {
    return React__default.createElement("div", { ...props });
}

export { Footer };
